import Button from './button';

/**
 * @deprecated use BX.UI.Button
 */
export default class PopupWindowButton extends Button
{

}